module.exports = __webpack_public_path__ + "img/PM_8.d19ec077.svg";